import { useEffect } from "react";

interface WorkspaceSelectionConfig {
  selectedWorkspace: string | null;
  workspaceList: Array<{ id: string }>;
  onGoHome?: () => void;
}

/**
 * Monitors workspace selection and falls back to home if the selected workspace
 * is no longer in the workspace list (e.g., user was removed from the workspace).
 */
export function useSidebarWorkspaceSelectionWithFallback({
  selectedWorkspace,
  workspaceList,
  onGoHome,
}: WorkspaceSelectionConfig) {
  useEffect(() => {
    if (
      selectedWorkspace &&
      workspaceList.length > 0 &&
      !workspaceList.some((w) => w.id === selectedWorkspace)
    ) {
      onGoHome?.();
    }
  }, [onGoHome, selectedWorkspace, workspaceList]);
}
